import { useEffect, useRef } from 'react'
import { useAuthStore, type UserSex } from '@/stores/auth'
import { fetchClientUserInfo } from '@/features/user/api'

export function AuthRecoveryBootstrap() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const expiresAt = useAuthStore((s) => s.expiresAt)
  const roles = useAuthStore((s) => s.roles)
  const userInfo = useAuthStore((s) => s.userInfo)
  const setRoles = useAuthStore((s) => s.setRoles)
  const setUserInfo = useAuthStore((s) => s.setUserInfo)
  const recoveringRef = useRef(false)
  const recoveredTokenRef = useRef<string | null>(null)
  const hasUserInfo = Boolean(userInfo?.userId || userInfo?.nickname)
  const hasPartialAuth = Boolean(accessToken) && (!hasUserInfo || roles.length === 0)

  useEffect(() => {
    if (!accessToken || !hasPartialAuth) return
    if (expiresAt && Date.now() > expiresAt) return
    if (recoveringRef.current || recoveredTokenRef.current === accessToken) return

    recoveringRef.current = true
    recoveredTokenRef.current = accessToken

    void fetchClientUserInfo()
      .then((info) => {
        const nextRoles = Array.from(new Set((info.roles ?? []).filter(Boolean)))
        setRoles(nextRoles)
        setUserInfo({
          userId: String(info.userId ?? ''),
          username: info.nickName ?? '',
          nickname: info.nickName ?? '',
          avatar: info.avatar,
          phonenumber: info.phonenumber,
          email: info.email,
          sex: normalizeUserSex(info.sex),
        })
      })
      .catch(() => {
        recoveredTokenRef.current = null
      })
      .finally(() => {
        recoveringRef.current = false
      })
  }, [accessToken, expiresAt, hasPartialAuth, setRoles, setUserInfo])

  return null
}

function normalizeUserSex(raw: string | undefined): UserSex | undefined {
  return raw === '0' || raw === '1' || raw === '2' ? raw : undefined
}
